import styled from 'styled-components';
import { PhotoCarouselSwipeableContainerMixin } from '../../mixins/components/PhotoCarouselSwipeableContainerMixin';
export var StyledPhotoCarouselSwipeableContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledPhotoCarouselSwipeableContainer",
  componentId: "c11n-8-111-1__sc-1mtdtql-0"
})(["", ""], PhotoCarouselSwipeableContainerMixin);